"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ORDERS = void 0;

var _existingOfflineOrder = require("./existingOfflineOrder");

var _general = require("./general");

var _pendingUpdates = require("./pendingUpdates");

var _singleOrder = require("./singleOrder");

var ORDERS = {
  EXISTING_OFFLINE_ORDER: _existingOfflineOrder.EXISTING_OFFLINE_ORDER,
  GENERAL: _general.GENERAL,
  PENDING_UPDATES: _pendingUpdates.PENDING_UPDATES,
  SINGLE_ORDER: _singleOrder.SINGLE_ORDER
};
exports.ORDERS = ORDERS;